export default function Line() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="247"
      height="41"
      viewBox="0 0 247 41"
    >
      <path d="M0,0H247V41H0Z" fill="none" />
      <path
        d="M214,11.774C214.823,6.14,211.624-.1,204.34,0q-39.9.534-79.646,4.065Q84.3,6.822,44.009,10.981a10.479,10.479,0,0,0-7.862,4.6Q21.7,18.072,7.307,20.93C-5.487,23.49-.071,43.326,12.7,40.774q26.248-5.252,52.695-9.118,85.905.4,171.811.8c13.054.06,13.069-20.516,0-20.576Q225.6,11.827,214,11.774Z"
        fill="#f0ff93"
      />
    </svg>
  )
}
